angular.module('app.directives.schedule').directive('rtmpSimulcastSettings', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '=',
    },
    template: require('./rtmp-simulcast-settings.html'),
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/rtmp-simulcast-settings.js